<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab" @change="handleTabClick">
        <ul class="tab-list">
          <li>
            <vxe-radio name="name1" label="tab1">基本信息</vxe-radio>
          </li>
          <li>
            <vxe-radio name="name1" label="tab2">企业信息</vxe-radio>
          </li>
          <li>
            <vxe-radio name="name2" label="tab3">银行账户</vxe-radio>
          </li>
          <li>
            <vxe-radio name="name3" label="tab4">邮寄地址</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
    </div>
    <div v-show="selectTab === 'tab1'">
      <base-info :userData="userData" @afterSave="queryUserInfoClientDetail"></base-info>
    </div>
    <div v-show="selectTab === 'tab2'">
      <comp-info :userData="userData"></comp-info>
    </div>
    <div v-show="selectTab === 'tab3'">
      <bank-account ref="bankAccount" :userId="userId" :isXcw="true" :realName="realName"></bank-account>
    </div>
    <div v-show="selectTab === 'tab4'">
      <mail-address ref="mailAddress" :userId="userId" :isXcw="true"></mail-address>
    </div>
  </div>
</template>
<script>
import BaseInfo from "@/components/userManage/BaseInfo";
import CompInfo from "@/components/userManage/CompInfo";
import $api from "@/apiProvider";
import BankAccount from "@/views/account/BankAccount";
import MailAddress from "@/views/account/MailAddress";

export default {
  props: ['userId'],
  components: {BaseInfo, CompInfo, BankAccount, MailAddress},
  data() {
    return {
      selectTab: "tab1",
      userData: {},
      dict: [],
      realName: null,
    }
  },
  watch: {
    userId: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val) {
          this.queryUserInfoClientDetail();
        }
      }
    }
  },
  created() {
    this.getAllDict();
  },
  methods: {
    handleTabClick(val) {
      let label = val.label;
      if (label === "tab3") {
        this.$refs.bankAccount.queryUserBankList(this.userId);
      }
      if (label === "tab4") {
        this.$refs.mailAddress.queryUserAddressList(this.userId);
      }
    },
    async getAllDict() {
      let res = await $api.dict.get("searchDic");
      if (res.status === 1) {
        this.dict = res.data;
      } else {
        this.$XModal.message(res.message);
      }
    },
    async queryUserInfoClientDetail() {
      let res = await $api.gcdUser.request("queryUserInfoClientDetail", {id: this.userId});
      if (res.status === 1) {
        if (res.data.tagsStr) {
          res.data.userGyl.userCategoryStr = res.data.tagsStr.split(',');
        }
        if (res.data.driverBeginTime) {
          res.data.userGyl.driverBeginTime = this.$utils.toDateString(res.data.driverBeginTime, "yyyy-MM-dd");
        }
        if (res.data.driverExpireTime) {
          res.data.userGyl.driverExpireTime = this.$utils.toDateString(res.data.driverExpireTime, "yyyy-MM-dd");
        }
        if (res.data.idCardExpireTime) {
          res.data.userGyl.idCardExpireTime = this.$utils.toDateString(res.data.idCardExpireTime, "yyyy-MM-dd");
        }
        if (res.data.transportExpireTime) {
          res.data.userGyl.transportExpireTime = this.$utils.toDateString(res.data.transportExpireTime, "yyyy-MM-dd");
        }

        res.data.userGyl.driverCardNum = res.data.driverCardNum;
        res.data.userGyl.idcardNum = res.data.idcardNum;
        res.data.userGyl.regAddr = res.data.regAddr;
        res.data.userGyl.weightType = res.data.weightType;
        res.data.userGyl.driverModel = res.data.driverModel;
        res.data.userGyl.email = res.data.email;
        res.data.userGyl.sex = res.data.sex;
        res.data.userGyl.imgUrl = res.data.imgUrl;
        res.data.userGyl.realName = res.data.realName;
        res.data.userGyl.issueAuthority = res.data.issueAuthority;
        res.data.userGyl.idcardBackUrl = res.data.idcardBackUrl;
        res.data.userGyl.idcardFrontUrl = res.data.idcardFrontUrl;
        res.data.userGyl.drivingCardFrontUrl = res.data.drivingCardFrontUrl;
        res.data.userGyl.drivingCardSubpageUrl = res.data.drivingCardSubpageUrl;
        res.data.userGyl.qualificationUrl = res.data.qualificationUrl;
        res.data.userGyl.transportLicenseNum = res.data.transportLicenseNum;
        res.data.userGyl.authStatus = res.data.authStatus;

        if (res.data.userComp && res.data.userComp.busiOwnArea) {
          res.data.userComp.busiOwnArea = res.data.userComp.busiOwnArea.split(',');
        }

        this.realName = res.data.realName;

        this.dict.map((i) => {
          if (parseInt(res.data.driverModel) === i.dictCode) {
            res.data.userGyl.driverModelText = i.dictText;
          }
        });

        this.userData = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
  }
}
</script>
<style>

</style>